import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Dropdown, Pagination} from 'react-bootstrap';
import {filterCustomersList, getCustomersList} from '../../../services/Dashboard';

function Customers() {
    const [customer, setCustomer] = useState([]);
    const [filterYear, setFilterYear] = useState(''); // State for input field
    const [currentPage, setCurrentPage] = useState(1); // Start with page 1 to match API
    const [totalItems, setTotalItems] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Number of items per page

    // Calculate pagination based on total items from API
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    
    // Handle page change
    const handlePageChange = async (pageNumber) => {
        setCurrentPage(pageNumber);
        if (filterYear) {
            await fetchFilteredCustomers(filterYear, pageNumber);
        } else {
            await fetchAllCustomers(pageNumber);
        }
    };
    
    // Handle page items change
    const handlePageItemsChange = async (newPageItems) => {
        setItemsPerPage(newPageItems);
        setCurrentPage(1); // Reset to first page when changing items per page
        if (filterYear) {
            await fetchFilteredCustomers(filterYear, 1, newPageItems);
        } else {
            await fetchAllCustomers(1, newPageItems);
        }
    };
    
    // Fetch all customers with pagination
    const fetchAllCustomers = async (page = 1, pageSize = itemsPerPage) => {
        try {
            const response = await getCustomersList(page, pageSize);
            setCustomer(response.data || []);
            setTotalItems(response.total_count || 0);
        } catch (error) {
            console.error('Error fetching customers:', error);
            setCustomer([]);
            setTotalItems(0);
        }
    };
    
    // Fetch filtered customers with pagination
    const fetchFilteredCustomers = async (year, page = 1, pageSize = itemsPerPage) => {
        try {
            const res = await filterCustomersList(year, page, pageSize);
            setCustomer(res.data || []);
            setTotalItems(res.total_count || 0);
        } catch (error) {
            console.error("Error fetching filtered customers:", error);
            setCustomer([]);
            setTotalItems(0);
        }
    };

    const handleFilterCustomers = async (year) => {
        setFilterYear(year.toString());
        setCurrentPage(1); // Reset to first page when filtering
        await fetchFilteredCustomers(year, 1);
    };

    // Handle input change and filter automatically
    const handleInputChangeAndFilter = async (e) => {
        const year = e.target.value;
        setFilterYear(year);
        
        if (year && year.length === 4) {
            setCurrentPage(1); // Reset to first page when filtering
            await fetchFilteredCustomers(parseInt(year), 1);
        } else if (year === '') {
            // If input is cleared, reload all customers
            setCurrentPage(1);
            await fetchAllCustomers(1);
        }
    };

    // Handle Enter key press in input
    const handleKeyPress = async (e) => {
        if (e.key === 'Enter' && filterYear) {
            setCurrentPage(1); // Reset to first page when filtering
            await fetchFilteredCustomers(parseInt(filterYear), 1);
        }
    };

    useEffect(() => {
        // Initial data load
        fetchAllCustomers(1);
    }, []);

    const handleResetCustomers = async () => {
        setFilterYear('');
        setCurrentPage(1);
        await fetchAllCustomers(1);
    };

    return (
        <>
            <div className='modal fade' id='addOrderModalside'>
                <div className='modal-dialog' role='document'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>Add Menus</h5>
                            <button
                                type='button'
                                className='close'
                                data-dismiss='modal'
                            >
                                <span>×</span>
                            </button>
                        </div>
                        <div className='modal-body'>
                            <form>
                                <div className='form-group'>
                                    <label className='text-black font-w500'>
                                        Food Name
                                    </label>
                                    <input
                                        type='text'
                                        className='form-control'
                                    />
                                </div>
                                <div className='form-group'>
                                    <label className='text-black font-w500'>
                                        Order Date
                                    </label>
                                    <input
                                        type='date'
                                        className='form-control'
                                    />
                                </div>
                                <div className='form-group'>
                                    <label className='text-black font-w500'>
                                        Food Price
                                    </label>
                                    <input
                                        type='text'
                                        className='form-control'
                                    />
                                </div>
                                <div className='form-group'>
                                    <button
                                        type='button'
                                        className='btn btn-primary'
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            
            <Dropdown className='dropdown custom-dropdown mb-md-4 mb-2'>
                <Dropdown.Toggle
                    type='button'
                    className='i-false btn btn-primary light d-flex align-items-center svg-btn'
                    data-toggle='dropdown'
                    aria-expanded='false'
                >
                    <svg
                        width={28}
                        height={28}
                        viewBox='0 0 28 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M24.5 6.125H12.25C12.25 5.15987 11.4651 4.375 10.5 4.375H8.75C7.78487 4.375 7 5.15987 7 6.125H3.5C3.017 6.125 2.625 6.51612 2.625 7C2.625 7.48388 3.017 7.875 3.5 7.875H7C7 8.84013 7.78487 9.625 8.75 9.625H10.5C11.4651 9.625 12.25 8.84013 12.25 7.875H24.5C24.983 7.875 25.375 7.48388 25.375 7C25.375 6.51612 24.983 6.125 24.5 6.125ZM8.75 7.875V6.125H10.5L10.5009 6.9965C10.5009 6.99825 10.5 6.99913 10.5 7C10.5 7.00087 10.5009 7.00175 10.5009 7.0035V7.875H8.75Z'
                            fill='#EA7A9A'
                        />
                        <path
                            d='M24.5 13.125H19.25C19.25 12.1599 18.4651 11.375 17.5 11.375H15.75C14.7849 11.375 14 12.1599 14 13.125H3.5C3.017 13.125 2.625 13.5161 2.625 14C2.625 14.4839 3.017 14.875 3.5 14.875H14C14 15.8401 14.7849 16.625 15.75 16.625H17.5C18.4651 16.625 19.25 15.8401 19.25 14.875H24.5C24.983 14.875 25.375 14.4839 25.375 14C25.375 13.5161 24.983 13.125 24.5 13.125ZM15.75 14.875V13.125H17.5L17.5009 13.9965C17.5009 13.9983 17.5 13.9991 17.5 14C17.5 14.0009 17.5009 14.0017 17.5009 14.0035V14.875H15.75Z'
                            fill='#EA7A9A'
                        />
                        <path
                            d='M24.5 20.125H12.25C12.25 19.1599 11.4651 18.375 10.5 18.375H8.75C7.78487 18.375 7 19.1599 7 20.125H3.5C3.017 20.125 2.625 20.5161 2.625 21C2.625 21.4839 3.017 21.875 3.5 21.875H7C7 22.8401 7.78487 23.625 8.75 23.625H10.5C11.4651 23.625 12.25 22.8401 12.25 21.875H24.5C24.983 21.875 25.375 21.4839 25.375 21C25.375 20.5161 24.983 20.125 24.5 20.125ZM8.75 21.875V20.125H10.5L10.5009 20.9965C10.5009 20.9983 10.5 20.9991 10.5 21C10.5 21.0009 10.5009 21.0017 10.5009 21.0035V21.875H8.75Z'
                            fill='#EA7A9A'
                        />
                    </svg>
                    <span className='fs-16 ml-3'>Filter</span>
                    <i className='fa fa-angle-down scale5 ml-3' />
                </Dropdown.Toggle>
                <Dropdown.Menu className='dropdown-menu dropdown-menu-right' style={{ minWidth: '200px' }}>
                    {/* Custom Year Input Section */}
                    <div className="px-3 py-2 border-bottom">
                        <label className="text-muted small mb-1">Custom Year</label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Enter year"
                            value={filterYear}
                            onChange={handleInputChangeAndFilter}
                            onKeyPress={handleKeyPress}
                            min="1900"
                            max="2030"
                            style={{ fontSize: '12px' }}
                        />
                    </div>
                    
                    {/* Preset Year Options */}
                    <div className="px-2 py-1">
                        <small className="text-muted px-2">Quick Select</small>
                    </div>
                    <Dropdown.Item className='dropdown-item' to='#' onClick={() => handleFilterCustomers(2025)}>
                        2025
                    </Dropdown.Item>
                    <Dropdown.Item className='dropdown-item' to='#' onClick={() => handleFilterCustomers(2024)}>
                        2024
                    </Dropdown.Item>
                    <Dropdown.Item className='dropdown-item' to='#' onClick={() => handleFilterCustomers(2023)}>
                        2023
                    </Dropdown.Item>
                    <Dropdown.Item className='dropdown-item' to='#' onClick={() => handleFilterCustomers(2022)}>
                        2022
                    </Dropdown.Item>
                    <Dropdown.Item className='dropdown-item' to='#' onClick={() => handleFilterCustomers(2021)}>
                        2021
                    </Dropdown.Item>
                    <Dropdown.Item className='dropdown-item' to='#' onClick={() => handleFilterCustomers(2020)}>
                        2020
                    </Dropdown.Item>
                    <Dropdown.Item className='dropdown-item' to='#' onClick={() => handleResetCustomers()}>
                        Reset
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

            <div className='row'>
                <div className='col-lg-12'>
                    <div className='table-responsive rounded card-table'>
                        <div
                            id='generalCustomer'
                            className='dataTables_wrapper no-footer'
                        >
                            <table
                                className='table border-no order-table mb-4 table-responsive-lg dataTablesCard dataTable no-footer'
                                id='example5'
                                role='grid'
                                aria-describedby='example5_info'
                            >
                                <thead>
                                    <tr role='row'>
                                        <th
                                            className='sorting_asc'
                                            tabIndex={0}
                                            aria-controls='example5'
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-sort='ascending'
                                            aria-label='Customer ID: activate to sort column descending'
                                            style={{width: 100, color: 'gray',fontSize: '14px'}}
                                        >
                                            CUSTOMER ID
                                        </th>
                                        <th
                                            className='sorting'
                                            tabIndex={0}
                                            aria-controls='example5'
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label='Join Date: activate to sort column ascending'
                                            style={{width: 166, color: 'gray',fontSize: '14px'}}
                                        >
                                            JOIN DATE
                                        </th>
                                        <th
                                            className='sorting'
                                            tabIndex={0}
                                            aria-controls='example5'
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label='Customer Name: activate to sort column ascending'
                                            style={{width: 126, color: 'gray',fontSize: '14px'}}
                                        >
                                            CUSTOMER NAME
                                        </th>
                                        <th
                                            className='sorting'
                                            tabIndex={0}
                                            aria-controls='example5'
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label='Location: activate to sort column ascending'
                                            style={{width: 184, color: 'gray',fontSize: '14px'}}
                                        >
                                            MOBILE NO
                                        </th>
                                        <th
                                            className='sorting'
                                            tabIndex={0}
                                            aria-controls='example5'
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label='Total Spent: activate to sort column ascending'
                                            style={{width: 90, color: 'gray',fontSize: '14px'}}
                                        >
                                            EMAIL
                                        </th>

                                        <th
                                            className='sorting'
                                            tabIndex={0}
                                            aria-controls='example5'
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label='Last Order: activate to sort column ascending'
                                            style={{width: 85, color: 'gray',fontSize: '14px'}}
                                        >
                                            LAST ORDER
                                        </th>
                                        <th
                                            className='sorting'
                                            tabIndex={0}
                                            aria-controls='example5'
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label='Last Order: activate to sort column ascending'
                                            style={{width: 85, color: 'gray',fontSize: '14px'}}
                                        >
                                            ACTIVE
                                        </th>
                                        <th
                                            className='sorting'
                                            tabIndex={0}
                                            aria-controls='example5'
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label=': activate to sort column ascending'
                                            style={{width: 26}}
                                        />
                                    </tr>
                                </thead>
                                <tbody>
                                    {customer && customer.length > 0 ? (
                                        customer.map((item, index) => (
                                            <tr
                                                key={item.cust_id || index}
                                                className='alert alert-dismissible border-0 odd'
                                                role='row'
                                            >
                                                <td className='sorting_1'>{item.cust_id}</td>
                                                <td>{item.created_on}</td>
                                                <td>{item.full_name}</td>
                                                <td>{item.mobile}</td>
                                                <td>{item.email}</td>
                                                <td>
                                                    <Link
                                                        className='btn btn-light btn-sm'
                                                        to='#'
                                                    >
                                                        SAR&nbsp;
                                                        {item.last_order_amount}
                                                    </Link>
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <i
                                                            className={`fa fa-circle ${
                                                                item.status
                                                                    ? 'text-success'
                                                                    : 'text-danger'
                                                            } mr-1`}
                                                        ></i>{' '}
                                                        {item.status
                                                            ? 'Active'
                                                            : 'Inactive'}
                                                    </div>
                                                </td>
                                                <td></td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center py-4">
                                                <div className="no-data-message">
                                                    <i className="fa fa-search-minus mb-3" style={{ fontSize: '2rem' }}></i>
                                                    <h5>No data found</h5>
                                                    <p className="text-muted">
                                                        {filterYear ? 
                                                            `No customer records found for year ${filterYear}.` : 
                                                            'No customer records match your search criteria.'
                                                        }
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {customer && customer.length > 0 && (
                                <div className='d-sm-flex text-center justify-content-between align-items-center mt-3'>
                                    <div
                                        className='dataTables_info'
                                        id='example5_info'
                                        role='status'
                                        aria-live='polite'
                                    >
                                        Showing {((currentPage - 1) * itemsPerPage) + 1} to{' '}
                                        {Math.min(currentPage * itemsPerPage, totalItems)}{' '}
                                        of {totalItems} entries
                                    </div>
                                    
                                    <div className='d-flex justify-content-between align-items-center flex-wrap'>
                                        {/* Enhanced Pagination controls */}
                                        <div className='dataTables_paginate paging_simple_numbers'>
                                            {totalPages > 1 && (
                                                <Pagination>
                                                    {/* First page button */}
                                                    <Pagination.First
                                                        disabled={currentPage === 1}
                                                        onClick={() => handlePageChange(1)}
                                                    />
                                                    
                                                    {/* Previous page button */}
                                                    <Pagination.Prev
                                                        disabled={currentPage === 1}
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                    />
                                                   
                                                    {/* Show page numbers with ellipsis for many pages */}
                                                    {[...Array(totalPages)].map((_, i) => {
                                                        const pageNum = i + 1;
                                                        // Always show first, last, current, and pages around current
                                                        if (
                                                            pageNum === 1 ||
                                                            pageNum === totalPages ||
                                                            (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
                                                        ) {
                                                            return (
                                                                <Pagination.Item
                                                                    key={pageNum}
                                                                    active={pageNum === currentPage}
                                                                    onClick={() => handlePageChange(pageNum)}
                                                                >
                                                                    {pageNum}
                                                                </Pagination.Item>
                                                            );
                                                        }
                                                       
                                                        // Show ellipsis for gaps
                                                        if (
                                                            (pageNum === 2 && currentPage > 3) ||
                                                            (pageNum === totalPages - 1 && currentPage < totalPages - 2)
                                                        ) {
                                                            return <Pagination.Ellipsis key={`ellipsis-${pageNum}`} />;
                                                        }
                                                       
                                                        return null;
                                                    })}
                                                   
                                                    {/* Next page button */}
                                                    <Pagination.Next
                                                        disabled={currentPage === totalPages}
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                    />
                                                    
                                                    {/* Last page button */}
                                                    <Pagination.Last
                                                        disabled={currentPage === totalPages}
                                                        onClick={() => handlePageChange(totalPages)}
                                                    />
                                                </Pagination>
                                            )}
                                        </div>

                                        {/* Dedicated Next/Previous buttons */}
                                        <div className='d-flex align-items-center mt-2 mt-sm-0 ml-0 ml-sm-3'>
                                            <button 
                                                className='btn btn-sm btn-outline-primary mr-2'
                                                disabled={currentPage === 1}
                                                onClick={() => handlePageChange(currentPage - 1)}
                                            >
                                                <i className='fa fa-chevron-left mr-1'></i>
                                                Previous
                                            </button>
                                            <button 
                                                className='btn btn-sm btn-outline-primary'
                                                disabled={currentPage === totalPages}
                                                onClick={() => handlePageChange(currentPage + 1)}
                                            >
                                                Next
                                                <i className='fa fa-chevron-right ml-1'></i>
                                            </button>
                                        </div>

                                       

                                        {/* Page size selector */}
                                        <div className='d-flex align-items-center mt-2 mt-sm-0 ml-0 ml-sm-3'>
                                            <span className='mr-2'>Items per page:</span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant='outline-primary' size='sm'>
                                                    {itemsPerPage}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => handlePageItemsChange(5)}>5</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handlePageItemsChange(10)}>10</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handlePageItemsChange(20)}>20</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handlePageItemsChange(50)}>50</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Customers;